import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { GlobalFilterBar } from "./GlobalFilterBar";
import { SIDEBAR_WIDTH, useSidebarCollapsed } from "../lib/sidebar";

export function AppShell() {
  const [filterOpen, setFilterOpen] = useState(false);
  const [collapsed] = useSidebarCollapsed();
  const width = collapsed ? SIDEBAR_WIDTH.collapsed : SIDEBAR_WIDTH.open;

  return (
    <div className="min-h-screen bg-surface-muted">
      <Sidebar />
      <div className={`${width.main} flex flex-col min-h-screen transition-[margin] duration-200`}>
        <Topbar
          onFilterToggle={() => setFilterOpen((o) => !o)}
          filterOpen={filterOpen}
        />
        <main className="flex-1 pt-16 overflow-x-hidden">
          <GlobalFilterBar open={filterOpen} />
          <div className="px-6 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
